import { render, staticRenderFns } from "./BankCardTermForm.vue?vue&type=template&id=6ff90c60&"
import script from "./BankCardTermForm.vue?vue&type=script&lang=js&"
export * from "./BankCardTermForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports